import React, { Component } from 'react'
import Chip from 'material-ui/Chip'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import config from '../../config/config'
import { getPlan, getToken, isAccountFree, isAccountStartter } from '../../lib'
import { fetchPlanDetails } from './actions'

const planStyle = {color: '#29B87A'}

class Details extends Component {
  constructor (props) {
    super(props)
  }

  componentDidMount = async () => {
    const plan = await getPlan()
    this.setState({plan})
    const token = getToken()
    this.props.fetchPlanDetails(token)
  }

  render () {
    return (
      <div style={{color: '#6B7C93'}}>
        {false && <div style={{fontSize: 12}} className='mb2'>
          <FormattedMessage id='plan.yourPlan'/>
        </div>}
        {false && <div className='mb2'>
          <Chip
            backgroundColor={(isAccountFree(this.props.plan)) ? '#4688F1' : (isAccountStartter(this.props.plan)) ? '#FFC514' : '#C347E1'}>
            <div
              style={{fontSize: 12}}
              className='white ttu'>
              {config.PLANS[this.props.plan]}
            </div>
          </Chip>
        </div>}
        <div className='pl4 pr4 mb4 mt4'>
          <div className='flex justify-between mb4'>
            <span>{'会社名'}</span>
            <span style={planStyle}>{this.props.planDetails.companyName}</span>
          </div>
          <div className='flex justify-between mb4'>
            <span>{'同時接続数'}</span>
            <span style={planStyle}>{this.props.planDetails.concurrency}</span>
          </div>
          {this.props.planDetails.status == 'expire' && <div className='flex justify-between mb4'>
            <span>{'有効期限'}</span>
            <span style={planStyle}>{this.props.planDetails.expirationDate}</span>
          </div>}
          <div className='flex justify-between mb4'>
            <span><FormattedMessage id='plan.recordingStorage'/></span>
            <span style={planStyle}>
          {this.props.planDetails.recordStorage}
          </span>
          </div>
          <div className='flex justify-between mb4'>
            <span>{'状態'}</span>
            <span style={planStyle}>{this.props.planDetails.contractStatus}</span>
          </div>
        </div>

        <div
          className='pl4 pr4 mb1 mt5'
          style={{lineHeight: '24px'}}>
          {'契約内容の変更やお問い合わせ:'}
          <br/>
          {'Email: webinar@anets.co.jp'}
          <br/>
          {'TEL: 03-5822-2038'}
          <br/>
          {'エイネット株式会社'}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    planDetails: state.planDetails
  }
}
const mapDispatchToProps = dispatch => ({
  fetchPlanDetails: (token) =>
    dispatch(fetchPlanDetails(token)),
})
export default connect(mapStateToProps, mapDispatchToProps)(
  Details
)



// WEBPACK FOOTER //
// ./src/components/PlanDetails/PlanDetails.js